/**
 * 个人信息Api
 * @author Sky
 */
import {
  userAreaMeList as manageQuery,
  userMeModify as updateUser,
  accountPasswordModify
} from '@/api/common'

export default {
  manageQuery, // 查询用户所属地区
  updateUser, // 修改用户
  accountPasswordModify // 修改密码
}
